import { editGreenMarkProjectData } from "../data/editGreenMarkProject.Data";

export const setFieldParameter = (apiResponse) => {
     editGreenMarkProjectData.initialState.projectName = apiResponse?.projectName || null
     editGreenMarkProjectData.initialState.greenMarkProjectNumber=apiResponse?.greenMarkProjectNumber || null
     editGreenMarkProjectData.initialState.dateofLetterofAward = apiResponse?.dateofLetterofAward || null
     editGreenMarkProjectData.initialState.awardRating=apiResponse?.awardRating || null
     editGreenMarkProjectData.initialState.gmapGreenMarkCategoryId=apiResponse?.gmapGreenMarkCategoryId || null
     editGreenMarkProjectData.initialState.developerBuildingOwner = apiResponse?.developerBuildingOwner || null
     editGreenMarkProjectData.initialState.describeYourRoleintheProject=apiResponse?.describeYourRoleintheProject || null
     editGreenMarkProjectData.initialState.endorsementAttachedFile = apiResponse?.endorsementAttachedFile || null
     editGreenMarkProjectData.initialState.greenMarkCategoryFile= apiResponse?.greenMarkCategoryFile || null
     editGreenMarkProjectData.initialState.remarks=apiResponse?.remarks || null
     editGreenMarkProjectData.initialState.CpdPoints=apiResponse?.cpdPoint || null
    
};